<template>
  <div id="app">
    <template v-if="route.path.startsWith('/user')">
      <router-view></router-view>
    </template>
    <template v-else>
      <BasicLayout></BasicLayout>
    </template>
  </div>
</template>

<style></style>
<script setup lang="ts">
import BasicLayout from "@/layout/BasicLayout.vue";
import { useRoute } from "vue-router";
import { useLoginUserStore } from "@/store/userStore";
import { onMounted } from "vue";

const loginUserStore = useLoginUserStore();
loginUserStore.fetchLoginUser();
const route = useRoute();

const doInit = () => {
  console.log("hello 欢迎来到我的项目");
};
onMounted(() => {
  doInit();
});
</script>
